import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ChangeRequestModule, Modules } from "../../constants/Module";
import { Action } from "../../constants/Common";
import { Spinner } from "reactstrap";
import InputAdornment from "@mui/material/InputAdornment";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";


const CostModule = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const newTaskObject = {
    projectCost: props?.projectMeta?.projectCost?.new ?? "",
  };

  const taskValidation = Yup.object().shape({
    projectCost: Yup.number()
      .moreThan(0, props.t("Cost cannot be 0 or negative"))
      .when('projectCost', {
        is: (value) => value,
        then: Yup.number().test(props.t('two decimal places'), props.t('Numbers can only have two decimal places'), (value) => {
          return value === null || (value && /^\d+(\.\d{0,2})?$/.test(String(value)))
      }), otherwise: Yup.number()
      })
      .optional(),
  }, ['projectCost', 'projectCost']);
  const formik = useFormik({
    initialValues: {
      ...newTaskObject,
    },
    validationSchema: taskValidation,
    validateOnMount: true,
    onSubmit: () => {
      setIsLoading(true);
      let hasChanges = false;
      if (formik.values.projectCost === props.project?.projectCost) {
        hasChanges = true;
      }
      if (!hasChanges) {
        const data = !formik.values.projectCost ? undefined : {
          projectCost: {
            old: props.project?.projectCost,
            new: formik.values.projectCost,
          }
        }
        props.validate(
          {
            module: ChangeRequestModule.PROJECT,
            event: Action.UPDATE,
            key: 'projectCost'
          },
          data,
          () => {
            setIsLoading(false);
          },
          () => {
            setIsLoading(false);
          }
        );
      } else {
        setIsLoading(false);
        toast.error("Current cost and updated cost cannot be same!");
      }
    },
  });

  const handleKeyDownCost = (event) => {
    if (event.keyCode === 8 || event.keyCode === 13) {
      return;
    }
    const value = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;

    if (!regex.test(value + event.key)) {
      event.preventDefault(); 
    }
  }
  
  return (
    <div>
      <div className="changeRequest_schedule">
        <h6 className="mb-0">{props.t('Current Cost')}</h6>
        <p className="mb-0 mt-1">SAR {parseFloat(props.project?.projectCost).toFixed(2)}</p>
      </div>
      <div className="changeRequest_schedule mt-3">
        <h6 className="mb-0">{props.t('Requested Cost')}</h6>
        <div className="row">
          <div className="col-md-12 changeRequest_datePicker mt-2">
            {/* <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Specify the change")}
              type="number"
              onWheel={(e) => e.target.blur()}
              disabled={isLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">SAR</InputAdornment>
                ),
              }}
              name="projectCost"
              value={formik.values.projectCost}
              onKeyDown={handleKeyDownCost}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            /> */}
            <TextField
                minimumValue="0"
                id="cost"
                variant="outlined"
                // label='Deliverable Cost'
                decimalPlaces={2}
                value={formik.values.projectCost}
                // size="small"
                currencySymbol={props.t("SAR")}
                fullWidth
                placeholder={props.t("Specify the change")}
                required

                disabled={isLoading}
                onChange={(e, newValue) => {
                  formik.setFieldValue('projectCost', newValue === 0 ? '' : newValue, true)
                }}
                onBlur={() => {
                  formik.setFieldTouched('projectCost', true, true)
                }}
              />
            {formik.touched.projectCost && formik.errors.projectCost && (
              <span className="text-danger">{formik.errors.projectCost}</span>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center mt-2">
        <button
          className={`edit_button ${
            isLoading ? "bg-secondary" : ""
          }`}
          disabled={isLoading}
          onClick={formik.handleSubmit}
        >
          {isLoading && (
            <Spinner className="ml-1 me-2" type="border" color="light" size="sm" />
          )}
          {props.t('Save Changes')}
        </button>
      </div>
    </div>
  );
};

export default withTranslation()(CostModule);
